import {
  ChangeDetectorRef,
  Component,
  HostListener,
  Input,
  OnInit,
  QueryList,
  ViewChildren,
} from "@angular/core";
import { forkJoin, Observable, of } from "rxjs";
import { map } from "rxjs/operators";
import { CameraComponent } from "src/app/annotation/camera/camera.component";
import { DeviceCheckService } from "src/app/core/survey/shared/services/device-check.service";
import { InsideSurvey } from "src/app/shared/Models/read";
import { ToastService } from "../../../../../../shared/toast.service";
import {
  InsideSurveyPhoto,
  INSIDE_SURVEY_PHOTO,
} from "../../../config/inside-survey.magic-strings";
import { InsideSurveyTab } from "../../../models/insideSurveyTab.interface";
import { FrameListService } from "../../../services/frameList.service";
import { BuildingService } from "src/app/core/building-list/services/building.service";
import { ValidationError } from "../../../../../../shared/Models/ValidationError";
import { InsideSurveyPhotoFormComponent } from "./inside-survey-photo-form/inside-survey-photo-form.component";
import { FormValidationService } from "../../../../shared/services/formValidation.service";

@Component({
  selector: "app-inside-survey-photo",
  templateUrl: "./inside-survey-photo.component.html",
  styleUrls: ["./inside-survey-photo.component.scss"],
})
export class InsideSurveyPhotoComponent implements InsideSurveyTab, OnInit {
  tabId: string = INSIDE_SURVEY_PHOTO;
  @Input() isAuthCanWrite: boolean;
  @Input() survey: InsideSurvey;
  @ViewChildren(InsideSurveyPhotoFormComponent)
  photosComp: QueryList<InsideSurveyPhotoFormComponent>;

  @Input() viewerLayer: HTMLDivElement;
  @Input() cameraLayer: HTMLDivElement;
  @Input() camera: CameraComponent;

  inPortrait: boolean;

  get showOpenButton$() {
    return this.frameListService
      .anyOpen(
        ...this.survey.buildings.reduce(
          (acc, b) => [...acc, ...b.addresses.map((a) => a.id)],
          []
        )
      )
      .pipe(map((b) => !b));
  }

  constructor(
    private deviceCheckService: DeviceCheckService,
    private frameListService: FrameListService,
    private toastService: ToastService,
    private formValidationService: FormValidationService,
    private buildinService: BuildingService
  ) {}

  ngOnInit(): void {
    this.inPortrait = this.deviceCheckService.onPortrait();
    this.survey.buildings.forEach((b) => {
      b.addresses.forEach((a) => {
        this.formValidationService.addFormError(
          [INSIDE_SURVEY_PHOTO, b.id, a.id],
          {
            [InsideSurveyPhoto.FACADE_PHOTO_SUBTITLE]: {
              [InsideSurveyPhoto.FACADE_PHOTO_FIELD]: false,
            },
          }
        );
      });
    });
  }

  @HostListener("window:resize")
  onResize() {
    this.inPortrait = this.deviceCheckService.onPortrait();
  }

  getValidationError(checkValidity?: boolean): ValidationError {
    let isValid = true;
    if (checkValidity)
      this.formValidationService.resetErrorsForPath(INSIDE_SURVEY_PHOTO);
    var i = 1;
    this.photosComp.forEach((component) => {
      if (
        component.address.isMainAddress === true &&
        component.viewmodel.facadePhotos.length === 0
      )
        if (checkValidity) {
          this.formValidationService.addError(
            INSIDE_SURVEY_PHOTO,
            this.survey.buildings[component.buildingIndex - 1].id,
            component.address.id,
            InsideSurveyPhoto.FACADE_PHOTO_SUBTITLE,
            InsideSurveyPhoto.FACADE_PHOTO_FIELD
          );
          isValid = false;
        }

      i++;
    });
    if (!isValid)
      return new ValidationError(
        $localize`:@@validation.photo.required:Photo is required`,
        $localize`:@@validation.survey.onefacadephotoforeachaddress:At least 1 facade photo is required for each address`,
        $localize`:@@survey.inside.technicalinfo.inside.photo:Inside Photo`
      );
    return undefined;
  }

  save(checkValidity?: boolean): Observable<boolean> {
    if (checkValidity && !this.isTabValid()) return of(false);

    if (this.isAuthCanWrite)
      return forkJoin(this.photosComp.map((comp) => comp.save())).pipe(
        map((res) => res.every((i) => i))
      );
  }

  private isTabValid() {
    if (!this.isAuthCanWrite) return true;

    let isValid = true;
    let i = 1;
    this.photosComp.forEach((component: InsideSurveyPhotoFormComponent) => {
      var mainAddressId = component.building.getMainAddress().id;
      if (
        component.address.id === mainAddressId &&
        component.viewmodel.facadePhotos.length === 0
      )
        isValid = false;

      i++;
    });

    if (!isValid)
      this.toastService.showWarnToast(
        $localize`:@@general.warning:Warning`,
        $localize`:@@validation.survey.onefacadephotoforeachaddress:At least 1 facade photo is required for each main address`
      );

    return isValid;
  }

  openAllFrames() {
    this.frameListService.open(
      ...this.survey.buildings.reduce(
        (acc, b) => [...acc, ...b.addresses.map((a) => a.id)],
        []
      )
    );
  }
  closeAllFrames() {
    this.frameListService.close(
      ...this.survey.buildings.reduce(
        (acc, b) => [...acc, ...b.addresses.map((a) => a.id)],
        []
      )
    );
  }
}
